import { createStorage } from '@aviata/storage';

import loaderLight from '@/assets/images/loader/kolsay-loader.webp?url';
import loaderDark from '@/assets/images/loader/kolsay-loader-dark.webp?url';

type FetchPriority = 'high' | 'low' | 'auto';

interface PreloadOptions {
  fetchPriority?: FetchPriority;
}

const preloadedUrls = new Set<string>();

const getLoaderUrl = (): string => {
  const storage = createStorage(localStorage);
  const theme = storage.get('theme');
  return theme === 'dark' ? loaderDark : loaderLight;
};

const schedule = (cb: () => void): void => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(cb);
    return;
  }
  setTimeout(cb, 200);
};

/**
 * Warms up the browser's image cache for the SERP loader background so that
 * when the user submits a search the `<img>` inside `SearchResultsLoader`
 * paints from cache with zero network delay.
 *
 * Safe to call multiple times: each URL is only downloaded once per session.
 * Defaults to low priority to avoid contending with critical app boot.
 */
export const preloadResultsLoaderAsset = (
  options: PreloadOptions = {},
): void => {
  const url = getLoaderUrl();

  if (preloadedUrls.has(url)) {
    return;
  }
  preloadedUrls.add(url);

  schedule(() => {
    const img = new Image();
    img.decoding = 'async';
    img.fetchPriority = options.fetchPriority ?? 'low';
    img.src = url;
  });
};
